﻿/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */
/**
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiElementVisibility".
 */
export type GuidedUiElementVisibility = "always" | "no-search-term" | "has-search-term" | "search-term-too-short" | "still-loading-after-1s" | "still-loading-after-5s" | "has-search-term-with-results-loaded";
/**
 * leave empty if unsure
 */
export type QuickLinkTemplateMapperType = string;
/**
 * Qualifier for the quicklinks to be shown within the section. NonEmpty list of items.
 *
 * @minItems 1
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "SectionSourcesList".
 */
export type ItemSources = [
    GuidedV2SectionSource,
    ...GuidedV2SectionSource[]
];
/**
 * Affects how quick link sections are filled with elements,
 * if default sections leave free slots. Additional sections.
 * All `default` are shown all the time assuming they have items,
 * The `low` are shown when default leave empty slots
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedQuickLinkImportance".
 */
export type GuidedQuickLinkImportance = "low" | "default";
export interface GuidedV2StrategyParams {
    /**
     * The country code for the current user, used to fetch localized content
     */
    country?: string;
    /**
     * The language code for the current user, used to fetch localized content
     */
    language?: string;
    /**
     * The amount of time to wait after the user stops typing before making a suggestion. If the user keeps typing - we don't send another call to the server.
     */
    debounceTimeMs?: number;
    /**
     * The amount of time for GuidedV2 to wait for the backend to respond before giving up. If the backend doesn't respond in this time, we abandon the query and assume it returned nothing.
     */
    backendTimeoutMs?: number;
    /**
     * If true, the backdrop will be shown when the guided is active. If false, the backdrop will not be shown.
     */
    useBackdrop: boolean;
    schema: GuidedV2Schema;
    /**
     * Enable the background scroll when the guided is active and the backdrop is visible
     */
    enableBackgroundScroll: boolean;
    quickLinkTemplateMapperType?: QuickLinkTemplateMapperType;
    /**
     * The threshold for the quicklink tag or attribute similarity with search term to be highlighted
     */
    badgeHighlightThreshold: number;
    /**
     * The threshold for the quicklink title or description similarity with search term to be highlighted
     */
    markupHighlightThreshold: number;
}
/**
 * Represents overall setup for Guided V2. Defines the main tabs in the guided,
 * what widgets belong to which tab, when they should be visible.
 * This way the guided can be easily configured and extended for different applications and user types. The most user-oriented configuration is done here.
 */
export interface GuidedV2Schema {
    /**
     * The minimal length of the search term to trigger the fetching. Default on =SE= is 3, but it prevents loading results before user interacts with the search bar, so we can't get history items. `0` is allowed.
     */
    minLength: number;
    /**
     * Tabs config - list of sections to be shown in the guided
     */
    sections: GuidedV2UiSection[];
}
/**
 * Generic type representing single section in guided tab
 * Single tab contains multiple widgets
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedV2UiSection".
 */
export interface GuidedV2UiSection {
    name: string;
    /**
     * Which tab to open when user submits the search query?
     */
    opensTab?: string;
    uiElements: Array<AbstractGuidedUiElement>;
    showWhen: GuidedUiElementVisibility;
}
/**
 * The actual schema for the guided v2
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedV2Schema".
 */
export interface GuidedV2Schema1 {
    /**
     * The minimal length of the search term to trigger the fetching. Default on =SE= is 3, but it prevents loading results before user interacts with the search bar, so we can't get history items. `0` is allowed.
     */
    minLength: number;
    /**
     * Tabs config - list of sections to be shown in the guided
     */
    sections: GuidedV2UiSection[];
}
/**
 * Main abstract class representing a UI element in the guided search. All widgets must inherit from it
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "AbstractGuidedUiElement".
 */
export abstract class AbstractGuidedUiElement {
    showWhen: GuidedUiElementVisibility;
    /**
     * Denotes the Component that will render the element.
     */
    static readonly type: string;
}
/**
 * Price & Availability section
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiPnaSection".
 */
export class GuidedUiPnaSection extends AbstractGuidedUiElement {
    /**
     * Used internally in Guided V2 to identify the component that will render this element.
     */
    static readonly type: "availability-suggestions" = "availability-suggestions";
    itemSources: ItemSources;
    label?: string;
    maxItems?: number;
}
/**
 * qualifier for the quicklinks to be shown within the sectoin
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedV2SectionSource".
 */
export interface GuidedV2SectionSource {
    searcher: string;
    category: string;
}
/**
 * UI Element containing quick-link result list
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiQuickLinkSection".
 */
export class GuidedUiQuickLinkSection extends AbstractGuidedUiElement {
    static readonly type: "quick-links" = "quick-links";
    clickTarget: string;
    slots: number;
    name: string;
    importance: GuidedQuickLinkImportance;
    itemSources: ItemSources;
}
/**
 * A banner to promote GenAI features
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiGenaiBanner".
 */
export class GuidedUiGenaiBanner extends AbstractGuidedUiElement {
    static readonly type: "genai-banner" = "genai-banner";
    text?: string;
    href?: string;
    target?: string;
    description?: string;
    buttonText?: string;
    searchTerm?: string;
    brand?: string;
}

export class GuidedUiNoResultMessage extends AbstractGuidedUiElement{
  static readonly type: 'no-result-message';
  itemSources: ItemSources;
  message: string;
  subTitle: string;
  /**
   * Message name for use with Label Provider, to ease translation we use simplified names, and the message is just
   * a fallback
   */
  messageName: string;
}
/**
 * Message to show when no quick links are found, should be translated.
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiNoLinksSection".
 */
export class GuidedUiNoLinksSection extends AbstractGuidedUiElement {
    static readonly type: "no-links-message" = "no-links-message";
    itemSources: ItemSources;
    message: string;
    /**
     * Message name for use with Label Provider, to ease translation we use simplified names, and the message is just a fallback
     */
    messageName: string;
    /**
     * What URL to open when user clicks the banner
     */
    clickTarget?: string;
}
/**
 * Setup for Popular Queries subcomponent, the one that shows keywords before user has typed the search query
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiPopularQueries".
 */
export class GuidedUiPopularQueries extends AbstractGuidedUiElement {
    /**
     * Denotes the Component that will render the element. Must comply with `UiClassMap` keys and `GuidedUiElementFactory` function
     */
    static readonly type: "popular-queries" = "popular-queries";
    itemSources: ItemSources;
    label: string;
    maxItems?: number;
}
/**
 * Setup for Promoted Keyword Suggestions subcomponent
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiPromotedSuggestions".
 */
export class GuidedUiPromotedSuggestions extends AbstractGuidedUiElement {
    static readonly type: "promoted-suggestions" = "promoted-suggestions";
    /**
     * Label displayed in the UI
     */
    label: string;
    maxItems?: number;
    itemSources: ItemSources;
}
/**
 * Featured quick links
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiFeaturedQuicklinks".
 */
export class GuidedUiFeaturedQuicklinks extends AbstractGuidedUiElement {
    static readonly type: "featured-quick-links" = "featured-quick-links";
    slots: number;
    itemSources: ItemSources;
}
/**
 * Featured CTA Banners
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiFeaturedBanners".
 */
export class GuidedUiFeaturedBanners extends AbstractGuidedUiElement {
    static readonly type: "featured-cta-banners" = "featured-cta-banners";
    slots: number;
    itemSources: ItemSources;
}
/**
 * Setup for Keyword Suggestions subcomponent, the one that shows keywords that expand the search query the user typed
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiKeywordSuggestions".
 */
export class GuidedUiKeywordSuggestions extends AbstractGuidedUiElement {
    static readonly type: "keyword-suggestions" = "keyword-suggestions";
    /**
     * Label displayed in the UI
     */
    label: string;
    maxItems?: number;
    itemSources: ItemSources;
}
/**
 * A banner with a button that can be clicked, usually in the guided footer
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiFooterBanner".
 */
export class GuidedUiFooterBanner extends AbstractGuidedUiElement {
    static readonly type: "footer-banner" = "footer-banner";
    text?: string;
    name?: string;
    description?: string;
    href?: string;
    target?: string;
    buttonText?: string;
    src?: string;
    brand?: string;
}
/**
 * History of Searches
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiHistoryOfSearches".
 */
export class GuidedUiHistoryOfSearches extends AbstractGuidedUiElement {
    static readonly type: "history-of-searches" = "history-of-searches";
    resultSlots: number;
    itemSources: ItemSources;
}
/**
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiSkeleton".
 */
export class GuidedUiSkeleton extends AbstractGuidedUiElement {
    static readonly type: "skeleton" = "skeleton";
    resultSlots: number;
    itemWidth: number | string;
    itemHeight?: number | string;
    displayMode?: "inline" | "inline-block" | "block";
    label?: string;
}
/**
 * Divider
 *
 * This interface was referenced by `GuidedV2StrategyParams`'s JSON-Schema
 * via the `definition` "GuidedUiDivider".
 */
export class GuidedUiDivider extends AbstractGuidedUiElement {
    static readonly type: "divider" = "divider";
}
